import axios from 'axios';

L.TileLayer.BetterWMS = L.TileLayer.WMS.extend({

    onAdd: function (map) {
        // Triggered when the layer is added to a map.
        //   Register a click listener, then do all the upstream WMS things
        L.TileLayer.WMS.prototype.onAdd.call(this, map);
        map.on('click', this.getFeatureInfo, this);
    },

    onRemove: function (map) {
        // Triggered when the layer is removed from a map.
        //   Unregister a click listener, then do all the upstream WMS things
        L.TileLayer.WMS.prototype.onRemove.call(this, map);
        map.off('click', this.getFeatureInfo, this);
    },

    getFeatureInfo: function (evt) {
        // Make an AJAX request to the server and hope for the best
        var url = this.getFeatureInfoUrl(evt.latlng),
            showResults = L.Util.bind(this.showGetFeatureInfo, this);

        axios.get(url)
            .then((data) => {

                const _BBOX = 'bbox';

                // verifica se a resposta contem dados
                if( data.data.features.length === 0 ){
                    showResults(evt.latlng, "Não existem informações para este ponto!");
                    return;
                }
                
                let props = data.data.features[0].properties;
                // converte o objeto para um array de propriedades
                props = Object.entries(props);

                // cria o header
                let resposta = undefined;
                resposta = "<div class='table-responsive'>" +
                           "<table class='table table-sm'>"+
                               "<thead>"+
                                   "<tr>"+
                                       "<th scope='col'>Atributo</th>"+
                                       "<th scope='col'>Valor</th>"+
                                   "</tr>"+
                               "</thead>" +
                               "<tbody>";
                props.map(p => {
                   if( p[0] !== _BBOX ) {
                    resposta += "<tr>"+
                                    "<th scope='row'>" + p[0] + "</th>" +
                                    "<td>" + p[1] + "</td>"+
                                "</tr>";     
                   }
                   return p;
                });

                resposta += "</tbody>"+
                            "</table>"+
                            "</div>";
                
                showResults(evt.latlng, resposta);
            })
            .catch(error => console.error("Erro ao tentar ler o getfeatureinfo ... ", error.message));
        /*
        $.ajax({
            url: url,
            success: function (data, status, xhr) {
                var err = typeof data === 'string' ? null : data;
                showResults(err, evt.latlng, data);
            },
            error: function (xhr, status, error) {
                showResults(error);
            }
        }); */
    },

    getFeatureInfoUrl: function (latlng) {
        // Construct a GetFeatureInfo request URL given a point
        var point = this._map.latLngToContainerPoint(latlng, this._map.getZoom()),
            size = this._map.getSize(),

            params = {
                request: 'GetFeatureInfo',
                service: 'WMS',
                srs: 'EPSG:4326',
                styles: this.wmsParams.styles,
                transparent: this.wmsParams.transparent,
                version: this.wmsParams.version,
                format: this.wmsParams.format,
                bbox: this._map.getBounds().toBBoxString(),
                height: size.y,
                width: size.x,
                layers: this.wmsParams.layers,
                cql_filter: this.wmsParams.cql_filter,
                env: this.wmsParams.env,
                query_layers: this.wmsParams.layers,
                //info_format: 'text/html'
                info_format: 'application/json'
            };

        params[params.version === '1.3.0' ? 'i' : 'x'] = point.x;
        params[params.version === '1.3.0' ? 'j' : 'y'] = point.y;

        return this._url + L.Util.getParamString(params, this._url, true);
    },

    showGetFeatureInfo: function (latlng, content) {

        L.popup({ maxWidth: 280, maxHeight: 350 })
            .setLatLng(latlng)
            .setContent(content)
            .openOn(this._map);
    }
});

L.tileLayer.betterWms = function (url, options) {
    return new L.TileLayer.BetterWMS(url, options);
};


// WEBPACK FOOTER //
// ./src/BetterWMS.js